/**
 * @generated SignedSource<<1abe10444d0ef9d340a56f245df58309>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSavedPromptInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteSavedPromptMutation_Mutation$variables = {
  input: DeleteSavedPromptInput;
};
export type DeleteSavedPromptMutation_Mutation$data = {
  readonly deleteSavedPrompt: {
    readonly deletedSavedPromptId: string;
  } | null;
};
export type DeleteSavedPromptMutation_Mutation = {
  variables: DeleteSavedPromptMutation_Mutation$variables;
  response: DeleteSavedPromptMutation_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSavedPromptPayload",
    "kind": "LinkedField",
    "name": "deleteSavedPrompt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSavedPromptId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSavedPromptMutation_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteSavedPromptMutation_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9768b4a62900b1c5bbfed2522b5611bf",
    "id": null,
    "metadata": {},
    "name": "DeleteSavedPromptMutation_Mutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSavedPromptMutation_Mutation(\n  $input: DeleteSavedPromptInput!\n) {\n  deleteSavedPrompt(input: $input) {\n    deletedSavedPromptId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c55971ea321fbbdf42d7a30011832d80";

export default node;
